import React, { useContext, useEffect, useState } from 'react';
import { validatePassword } from 'utils/passwordUtils';
import PasswordInput from 'components/UI/PasswordInput';
import { ColorContext } from 'App';
import { Button } from 'react-bootstrap';
import { updateFusionPassword } from 'services/account/account.service';

export const UpdatePassword = ({ setShowChangePassword }) => {
  const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [error, setError] = useState(null);
  const theme = useContext(ColorContext);

  const handleSubmit = () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!currentPassword) {
      setError('Original password is required');
      return;
    }

    if (!validatePassword(newPassword).isValid) {
      setError(validatePassword(newPassword).message);
      return;
    }
    setError(null);
    // make api call to change password
    (async () => {
      try {
        const res = await updateFusionPassword(currentPassword, newPassword);

        setError('Password changed successfully');
        // setShowChangePassword(false);
        setChangePasswordSuccess(true);

        setConfirmPassword(null);
        setCurrentPassword(null);
        setNewPassword(null);
      } catch (e) {
        setError('Error changing password: ' + e.response.data.message);
      }
    })();
  };

  useEffect(() => {
    if (newPassword === null || confirmPassword === null || currentPassword == null) {
      setError(null);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (newPassword === currentPassword) {
      setError('New password cannot be the same as the current password');
      return;
    }
    if (!validatePassword(newPassword).isValid) {
      setError(validatePassword(newPassword).message);
      return;
    }

    setError(null);
  }, [newPassword, confirmPassword]);

  if (!changePasswordSuccess)
    return (
      <div
        className="w-100 d-flex flex-column align-content-start p-2"
        style={{ backgroundColor: theme.base }}
      >
        <div>
          <Button
            className="py-2 px-3 border-3 mb-2 rounded-5"
            onClick={() => {
              setShowChangePassword(false);
              setConfirmPassword(null);
              setCurrentPassword(null);
              setNewPassword(null);
            }}
            style={{ background: theme.primary }}
          >
            Back
          </Button>
        </div>
        <div className="p-1 d-flex flex-column justify-content-between w-100 max-w-md">
          <PasswordInput
            label="Current password"
            callback={setCurrentPassword}
            value={currentPassword}
          />
        </div>
        <div className="p-1 d-flex flex-column justify-content-between w-100 max-w-md">
          <PasswordInput label="New password" callback={setNewPassword} value={newPassword} />
        </div>
        <div className="p-1 d-flex flex-column justify-content-between w-100 max-w-md">
          <PasswordInput
            label="Confirm new password"
            callback={setConfirmPassword}
            value={confirmPassword}
          />
        </div>
        <Button
          className="py-2 px-3 mb-2 max-w-sm mt-5 rounded-5"
          onClick={handleSubmit}
          style={{ background: theme.primary }}
        >
          Update Password
        </Button>
        {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
      </div>
    );

  if (changePasswordSuccess)
    return (
      <div
        className="w-100 d-flex flex-column align-content-start p-2"
        style={{ backgroundColor: theme.base }}
      >
        Password Update Successful
        <Button
          className="py-2 px-3 mb-2 max-w-sm mt-5 rounded-5"
          onClick={() => {
            setShowChangePassword(false);
            setChangePasswordSuccess(false);
            setConfirmPassword(null);
            setCurrentPassword(null);
            setNewPassword(null);
          }}
          style={{ background: theme.primary }}
        >
          Return to Account
        </Button>
      </div>
    );
};
